;
(function ($) {
    "use strict";

    // Only do this stuff if we are on the search page:
    if (!$('body.page-template-template-search-php').length) return false;

    var APP_CONTAINER_ID = 'professional-search';

    let manager_id = false;
    const position_data = ('undefined' == typeof(window.professional_search_position_data) ) ?
        [] : window.professional_search_position_data.filter( (el) => {
            if ("manager" === el.name.toLowerCase()) manager_id = el.id
            return "manager" != el.name.toLowerCase();
        } );;

    const practice_data = ('undefined' == typeof(window.professional_search_practice_data) ) ?
        [] : window.professional_search_practice_data;

    const school_data = ('undefined' == typeof(window.professional_search_school_data) ) ?
        [] : window.professional_search_school_data.sort((a, b) => {
            if(a.name < b.name) return -1;
            if(a.name > b.name) return 1;
            return 0;
        });

    var search_data_initial_response = ('undefined' == typeof(window.professional_search_data) ) ?
            [] : window.professional_search_data.sort((a, b) => {
            if(a.sort_name < b.sort_name) return -1;
            if(a.sort_name > b.sort_name) return 1;
            return 0;
        })

    const school_list_mult = _.pluck(search_data_initial_response, 'education')
        .map((el) => {
            return el.split(',', 1)[0];
        })
        .sort()
        .filter( (el) => {return el != "";});
    const school_list_full = _.uniq(school_list_mult);

    const urlParams = new URLSearchParams(window.location.search);
    const query_search_string = urlParams.has('professionalSearchString') ?
        urlParams.get('professionalSearchString') : false;
    const query_search_letter = urlParams.has('letter') && !query_search_string ?
        urlParams.get('letter') : false;


    let initial_filter = false;
    if (query_search_string) {
        initial_filter = 'INPUT_FILTER'
    } else if (query_search_letter) {
        initial_filter = 'LETTER_FILTER'
    }

    // Vue.use(VAutocomplete.default)

    var app = new Vue({
        el: '#' + APP_CONTAINER_ID,
        data: {
            letter_selector: query_search_letter ? query_search_letter : false,
            search_string: query_search_string ? query_search_string : '',
            complete_search_data: search_data_initial_response,
            active_filter: initial_filter,
            search_drawer_open: false,
            filter_practice: "",
            filter_position: "",
            filter_school: "",
            positions: position_data,
            practices: practice_data,
            schools: school_data,
        },
        computed: {
            filtered_responses: function () {

                const full_set = this.complete_search_data;

                // advanced filter :::

                const filtered_set = full_set.filter( (el) => {
                        // no managers
                        return (!el.position_ids.includes());
                    }).filter( (el) => {
                        // Position
                        return ("" === this.filter_position || el.position_ids.includes(this.filter_position));
                    }).filter( (el) => {
                        // by practice
                        return ("" === this.filter_practice || el.practice_ids.includes(this.filter_practice));
                    }).filter( (el) => {
                        // By School
                        return ("" === this.filter_school || el.school_ids.includes(this.filter_school));
                    });

                // basic filter :::
                switch (this.active_filter) {
                    case false:
                        return filtered_set;
                    case 'INPUT_FILTER':
                        if ('' == this.search_string)
                            return filtered_set;

                        const string_set = this.search_string.split(' ').filter(el => el != '');

                        const search_regex = new RegExp(string_set.join('|'), 'i');

                        return filtered_set.filter((el) => {
                            if (!el.name) return false;
                            return search_regex.exec(el.name);
                        });

                    case 'LETTER_FILTER':
                        var letter = this.letter_selector;
                        return filtered_set.filter(function (el) {
                            return el.sort_name && el.sort_name.lastIndexOf(letter, 0) === 0
                        });
                }
            },
            message: function () {
                if (this.filtered_responses.length == 0)
                    return "No professionals found.";
                return false;
                return 'Searching... <i class="fa fa-cog fa-spin"></i>';
            }
        },
        methods: {
            position_id_manager: function () {
                return manager_id;
            },
            letter_class: function (letter) {
                let out_string = '';
                if (this.isCurrentLetter(letter)) out_string = out_string + ' current';
                if (this.isUsefulLetter(letter)) out_string = out_string + ' active';
                return out_string;
            },
            isUsefulLetter: function (letter) {
                const full_set = this.complete_search_data;
                return full_set.filter((el) => {
                    return el.sort_name && el.sort_name.lastIndexOf(letter, 0) === 0
                }).length >= 1;
            },
            isCurrentLetter: function (letter) {
              return letter == this.letter_selector;
            },
            toggleSearchDrawer: function () {
                this.search_drawer_open = !this.search_drawer_open;
            },
            selectLetter: function (ev) {
                var letter = $(ev.target).data('letter');
                if (!this.isUsefulLetter(letter)) return false;
                this.active_filter = 'LETTER_FILTER';
                this.letter_selector = letter;
                this.search_string = '';
            }, 
            resetAdvanced: function (ev) {
                this.filter_practice = "";
                this.filter_position = "";
                this.filter_school = "";
                this.active_filter = false;
                this.letter_selector = false;
                this.search_string = '';                
            }
        },
        watch: {
            'search_string': function (val, oldVal) {
                if ('' == val && 'INPUT_FILTER' == this.active_filter) {
                    this.active_filter = false;
                } else if ('' == val && 'LETTER_FILTER' == this.active_filter) {
                    // keep the filter
                } else {
                    this.active_filter = 'INPUT_FILTER';
                }
            }

        }
    })

})(jQuery);